import React from 'react';
import {DialogFooter} from '@taopix/taopix-design-system';
import {useUiState} from '../Context/UserInterface/UserInterfaceContext';

type AssistantFooterProps = {
  children?: any;
};

export const AssistantFooter = ({children}: AssistantFooterProps) => {
  const ui = useUiState();

  return (
    <DialogFooter alignment="none" isSmallScreen={ui.state.isSmallScreen} className="m-0 p-0">
      {children}
    </DialogFooter>
  );
};
